import React, { Component, Fragment } from "react";
import { graphql } from "react-apollo";
import { compose, lifecycle } from "recompose";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";

import withErrorState from "../hocs/withErrorState";
import withLoadingState from "../hocs/withLoadingState";
import withLocalization from "../hocs/withLocalization";
import withFlattenedTranslations from "../hocs/withFlattenedTranslations";
import withPageInfo from "../hocs/withPageInfo";
import withGeneralTranslations from "../hocs/withGeneralTranslations";
import withConnectionStatus from "../hocs/withConnectionStatus";
import withNotFoundWhenEmpty from "../hocs/withNotFoundWhenEmpty";

import buildAssetUrl from "../utils/buildAssetUrl";
import normalizeHotspots from "../utils/normalizeHotspots";

import { SummaryBar, TopicSection, IntroSection, ComponentSection } from "../components";
import Navigation from "../layouts/Navigation";

import { sharedComponentStyles } from "./Component";
import topicQuery from "../queries/topic";
import PodcastsReferences from "../components/PodcastsReferences";

// TODO: separate content & container, and compose graphql only with content
// to ensures that only the content is affected by loading/error states

class Topic extends Component {
    componentDidMount() {
        this.updatePageInfo();
    }

    componentDidUpdate() {
        this.updatePageInfo();
    }

    updatePageInfo() {
        const { topic, pageInfo, setPageInfo } = this.props;
        const { id, title } = topic;
        if (pageInfo.title !== title || pageInfo.id !== id) {
            setPageInfo({
                id,
                title,
                type: "topic",
            });
        }
    }

    render() {
        const { topic, generalTranslations, location, classes } = this.props;
        const { title, headline, description, sections } = topic;

        const isTopicClusterTopic = location.pathname.indexOf("/topic-cluster/") === 0;

        return (
            <Fragment>
                <Navigation enableOverviewShortcuts={!isTopicClusterTopic} />
                <div className={classes.mainWrapperStyle}>
                    <IntroSection
                        kicker={generalTranslations("topic").toUpperCase()}
                        title={title}
                        headline={headline}
                        description={description}
                    >
                        <PodcastsReferences podcasts={topic.podcasts} />
                    </IntroSection>
                    <SummaryBar sections={sections} />

                    <div className={classes.sectionsWrapperStyle}>
                        {sections.map((section, index) => {
                            const {
                                headline,
                                description,
                                slug,

                                assetWithDescription,
                                table,

                                hotspotImage,
                                localizedHotspotImage,
                                hotspots,
                            } = section;

                            if (hotspotImage) {
                                const image = localizedHotspotImage || hotspotImage;

                                const normalizedHotspots = normalizeHotspots(image, hotspots);

                                const { url: imageUrl } = buildAssetUrl(image);

                                return (
                                    <TopicSection
                                        headline={headline}
                                        description={description}
                                        image={imageUrl}
                                        hotspots={normalizedHotspots}
                                        isLastSection={index === sections.length - 1}
                                        key={slug}
                                        anchorId={slug}
                                    />
                                );
                            }

                            return (
                                <ComponentSection
                                    headline={headline}
                                    description={description}
                                    medias={assetWithDescription || []}
                                    isLastSection={index === sections.length - 1}
                                    key={slug}
                                    anchorId={slug}
                                    table={table}
                                />
                            );
                        })}
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default compose(
    withConnectionStatus,
    withGeneralTranslations,
    withLocalization,
    graphql(topicQuery, {
        options: ({ language, match, fetchPolicy, stage }) => ({
            variables: {
                slug: match.params.slug,
                lang: language.toLowerCase(),
                stage,
            },
            fetchPolicy,
        }),
    }),
    withErrorState,
    withLoadingState("topic"),
    withNotFoundWhenEmpty("topic"),
    withFlattenedTranslations("topic"),
    withPageInfo,
    withRouter,
    withStyles(sharedComponentStyles)
)(Topic);

const TopicPrintView = ({ generalTranslations, topic, classes }) => {
    const { title, headline, description, sections } = topic;

    if (!title || !headline || !description || !sections) {
        return <div>Component not fully loaded, cannot be printed!</div>;
    }

    return (
        <Fragment>
            <div className={classes.mainWrapperStyle}>
                <IntroSection
                    kicker={generalTranslations("topic").toUpperCase()}
                    title={title}
                    headline={headline}
                    description={description}
                />

                <div className={classes.sectionsWrapperPrintStyle}>
                    {sections.map((section, index) => {
                        const { headline, description, hotspotImage, localizedHotspotImage, hotspots, slug } = section;

                        const image = localizedHotspotImage || hotspotImage;

                        const normalizedHotspots = normalizeHotspots(image, hotspots);

                        const { url: imageUrl } = buildAssetUrl(image);

                        return (
                            <TopicSection
                                headline={headline}
                                description={description}
                                image={imageUrl}
                                hotspots={normalizedHotspots}
                                isLastSection={index === sections.length - 1}
                                key={slug}
                                anchorId={slug}
                            />
                        );
                    })}
                </div>
            </div>
        </Fragment>
    );
};

export const TopicPrint = compose(
    withConnectionStatus,
    withGeneralTranslations,
    withLocalization,
    graphql(topicQuery, {
        options: ({ language, slug, fetchPolicy, stage }) => ({
            variables: {
                slug: slug,
                lang: language.toLowerCase(),
                stage,
            },
            fetchPolicy,
        }),
    }),
    withErrorState,
    withLoadingState("topic"),
    withNotFoundWhenEmpty("topic"),
    withFlattenedTranslations("topic"),
    withStyles(sharedComponentStyles),
    lifecycle({
        componentDidMount() {
            this.props.onMounted(this.props.slug);
        },
    })
)(TopicPrintView);



// WEBPACK FOOTER //
// ./src/screens/Topic.js